import * as actionTypes from "./actionTypes";

const supplierReducer = (state = [], payload) => {
  switch (payload.type) {
    case actionTypes.ADD_SUPPLIER_SUCCESS:
      return [...payload.suppliers];

    case actionTypes.EDIT_SUPPLIER_SUCCESS:
      return [...payload.suppliers];

    case actionTypes.DELETE_SUPPLIER_SUCCESS:
      return [...payload.suppliers];
      
    case actionTypes.GET_SUPPLIERS_SUCCESS:
      return [...payload.suppliers];

    default:
      return state;
  }
};

export default supplierReducer;
